import { useMemo } from 'react';

import { getPackageVersion } from './getPackageVersion.tsx';

export const useVersioningDataProps = () => {
  return useMemo(() => {
    const { tag, distance, hash } = getPackageVersion();

    return {
      'data-shared-header-footer--tag': tag,
      'data-shared-header-footer--hash': hash,
      'data-shared-header-footer--tag-distance': distance,
    };
  }, []);
};
